import React, { useState } from 'react';
import { Card, Form, Input, Select, Typography, Button } from 'antd';

const { Title, Paragraph, Text } = Typography;
const { Option } = Select;

const WLBranding = () => {
  const [submitting, setSubmitting] = useState(false);

  const handleFinish = (values) => {
    setSubmitting(true);
    setTimeout(() => {
      console.log('White label branding config', values);
      setSubmitting(false);
    }, 500);
  };

  return (
    <div className="wl-branding">
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Branding & Experience
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 16 }}>
          Configure how Asuma appears for your partner companies. This is a visual configuration form only – hook it
          up to your API when you are ready to persist settings.
        </Paragraph>

        <Card style={{ borderRadius: 14 }}>
          <Form layout="vertical" onFinish={handleFinish} initialValues={{ theme: 'dark' }}>
            <Form.Item label="Product name" name="productName">
              <Input placeholder="e.g. Acme Insights" />
            </Form.Item>

            <Form.Item label="Primary color" name="primaryColor">
              <Input placeholder="#6366f1" />
            </Form.Item>

            <Form.Item label="Accent color" name="accentColor">
              <Input placeholder="#22c55e" />
            </Form.Item>

            <Form.Item label="Theme" name="theme">
              <Select>
                <Option value="light">Light</Option>
                <Option value="dark">Dark</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Login logo URL" name="logoUrl">
              <Input placeholder="https://yourcdn.com/logo.png" />
            </Form.Item>

            <Form.Item label="Support contact email" name="supportEmail">
              <Input placeholder="support@yourcompany.com" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={submitting}>
                Save configuration (demo)
              </Button>
            </Form.Item>
          </Form>

          <Text type="secondary">
            Submitting this form only logs the values in the browser console for now. Replace the handler with a real
            API call when you are ready.
          </Text>
        </Card>
      </div>
    </div>
  );
};

export default WLBranding;
